<template>

  <v-container fluid grid-list-xl>

    <H2 class="ma=3">Customer Code : {{this.$store.getters.get_user_code }}  {{this.$store.getters.get_user_name }}  </H2>
    <v-divider></v-divider>

        <v-container fluid grid-list-xl>
            <v-layout row wrap>     
                <v-flex d-flex >
                    <view_table_order_hist/>
                </v-flex>
            </v-layout>
        </v-container>

    </v-container>

</template>

<script>
export default {
  data() {
    return {

    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/credit_list.vue